/** Shared status normalisation for pills/dots — maps backend status strings
 *  to the four semantic verdicts. Green is a verdict: color only ever means
 *  transaction state. */
export type ErStatusKind = 'success' | 'pending' | 'failed' | 'info' | 'neutral';

export function normalizeStatus(raw: string | null | undefined): ErStatusKind {
  const s = (raw || '').toString().trim().toLowerCase();
  if (!s) { return 'neutral'; }
  if (/(success|complete|completed|approved|active|paid|credit|done|accepted)/.test(s)) { return 'success'; }
  if (/(pending|process|processing|initiated|await|hold|progress|queued|requested)/.test(s)) { return 'pending'; }
  if (/(fail|failed|declin|reject|block|error|expired|cancel)/.test(s)) { return 'failed'; }
  if (/(refund|revers|info)/.test(s)) { return 'info'; }
  return 'neutral';
}
